import { put, takeLatest } from "redux-saga/effects";

import {
  requestClientExitChecklistListList,
  requestCreateClientExitChecklist,
  requestUpdateClientExitChecklist
} from "../../../services/clientExitChecklist";
import {
  fetchClientExitChecklistListFailure,
  fetchClientExitChecklistListSuccess,
  fetchClientExitChecklistListRequest,
  createClientExitChecklistFailure,
  createClientExitChecklistSuccess,
  createClientExitChecklistRequest,
  updateClientExitChecklistRequest,
  updateClientExitChecklistSuccess,
  updateClientExitChecklistFailure,
} from "../../reducers/clientExitChecklist";

export function* watchClientExitChecklistSaga() {
  yield takeLatest(
    fetchClientExitChecklistListRequest,
    fetchClientExitChecklistList
  );
  yield takeLatest(createClientExitChecklistRequest, createClientExitChecklist);
  yield takeLatest(updateClientExitChecklistRequest, updateClientExitChecklist);
}

/**
 *
 * @param {*} param0
 */
function* fetchClientExitChecklistList({ payload }) {
  try {
    const response = yield requestClientExitChecklistListList(payload);
    yield put(fetchClientExitChecklistListSuccess(response));
  } catch (error) {
    yield put(
      fetchClientExitChecklistListFailure("Failed to get Client Exit Checklist")
    );
  }
}

/**
 *
 * @param {SmartProposalState} param0
 */
 function* createClientExitChecklist({ payload }) {
  try {
    //service add
    const response = yield requestCreateClientExitChecklist(payload);
    yield put(createClientExitChecklistSuccess(response.data));
  } catch (error) {
    yield put(
      createClientExitChecklistFailure("Failed to create Client Exit Checklist")
    );
  }
}

function* updateClientExitChecklist({ payload }) {
  try {
    const response = yield requestUpdateClientExitChecklist(payload);
    yield put(updateClientExitChecklistSuccess(response.data));
  } catch (error) {
    yield put(updateClientExitChecklistFailure("Failed to get update ClientSpoc"));
  }
}